<template>
  <div>
    <v-dialog v-model="show" persistent max-width="800px">
      <v-card class="dialog">
        <v-toolbar class="grey lighten-3">
          <span class="headline primary--text"> Disclaimer </span>
          <v-spacer />
          <v-btn icon @click="closeDialog()">
            <v-icon color="primary"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-container style="max-height: 50vh; overflow-y: auto">
          <v-row>
            <v-col>
              <p class="font-weight-light">
                The information contained herein is provided as a public service
                and is for NONCOMMERCIAL PURPOSES ONLY, with the understanding
                that the Colorado State Forest Service and Colorado State
                University make no warranties, either expressed or implied,
                concerning the accuracy, completeness, reliability, or
                suitability of the information. Nor does the Colorado State
                Forest Service or Colorado State University warrant that the use
                of this information is free of any claims of copyright
                infringement. THE INFORMATION IS BEING PROVIDED "AS IS" AND
                WITHOUT WARRANTY OF ANY KIND EITHER EXPRESS, IMPLIED OR
                STATUTORY, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES
                OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
              </p>
              <p class="font-weight-light">
                Users also should note that property boundaries included in any
                product do not represent an on-the-ground survey suitable for
                legal, engineering, or surveying purposes. They represent only
                the approximate relative locations.
              </p>
              <p class="font-weight-light">
                By accessing this website and/or data contained within the
                databases, you hereby release the Board of Governors of the
                Colorado State University System, Colorado State University and
                the Colorado State Forest Service, their employees, agents,
                contractors, and suppliers (collectively, "CSFS") from any and
                all responsibility and liability associated with its use. In no
                event shall CSFS be liable for any damages arising in any way
                out of the use of the website, or use of the information
                contained in the databases herein including, but not limited to
                the Colorado Forest Atlas and Colorado Wildfire Risk Assessment
                products.
              </p>
              <p class="font-weight-light">
                The user assumes the entire risk related to their use of this
                information, including but not limited to the Colorado State
                Wildfire Risk Assessment, the Colorado Forest Atlas, and either
                the published or derived products from these data. IN NO EVENT
                WILL CSFS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT,
                INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL OR EXEMPLARY
                DAMAGES OR LOST PROFIT RESULTING FROM ANY USE OR MISUSE OF THESE
                DATA, EVEN IF THE USER HAS BEEN ADVISED OF THE POSSIBILITY OF
                SUCH DAMAGES.
              </p>
            </v-col>
          </v-row>
        </v-container>
        <v-toolbar class="grey lighten-3 d-flex justify-end">
          <v-btn
            color="primary"
            @click="
              remember = true;
              closeDialog();
            "
          >
            Accept - Never Show Again
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      dialog: true,
      remember: false,
    };
  },
  methods: {
    closeDialog() {
      if (this.remember) {
        window.localStorage.setItem("DisclaimerDialog", true);
      }
      this.$emit("close");
    },
  },
};
</script>
